/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsContainerFindingsSBOMVersionIdsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsContainerFindingsSBOMVersionIdsQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsContainerFindingsSBOMVersionIdsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsContainerFindingsSBOMVersionIdsQueryOperator>): AppSecopsContainerFindingsSBOMVersionIdsQueryOperator {
        let obj = Object.assign(new AppSecopsContainerFindingsSBOMVersionIdsQueryOperator(), model);
        AppSecopsContainerFindingsSBOMVersionIdsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsContainerFindingsSBOMVersionIdsQueryOperator>): AppSecopsContainerFindingsSBOMVersionIdsQueryOperator {
        if (!model) return null;
        return AppSecopsContainerFindingsSBOMVersionIdsQueryOperator.newInstance(<AppSecopsContainerFindingsSBOMVersionIdsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsContainerFindingsSBOMVersionIdsQueryOperator) {
        if (!obj) return;

        models.AppSecopsContainerFindingsSBOMVersionIdsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsContainerFindingsSBOMVersionIdsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsContainerFindingsSBOMVersionIdsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * SBOM version IDs to include
     */
    sbom_version_ids: Array<string>;

}
